export { IconArrowBack1 } from "./IconArrowBack1";
